module.exports = __webpack_public_path__ + "static/metodologia-5aa511d54439f18254c778322c65bed4.png";